import {
  Component,
  HostListener,
  OnInit,
} from '@angular/core';

import { HomeService } from 'src/app/services/home.service';
import { Knowledge } from 'src/app/models/knowledge.model';
import { SharedService } from 'src/app/services/shared.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-knowledges',
  templateUrl: './knowledges.component.html',
  styleUrls: ['./knowledges.component.css']
})
export class KnowledgesComponent implements OnInit {

  knowledges: Knowledge[] = [];

  showSpinner = false;
  loadingMore = false;
  hasNextPage = true;

  pageSize = 12;
  lastDoc: any = null;

  constructor(
    private homeService: HomeService,
    private sharedService: SharedService,
    private titleService: Title
  ) {}

  ngOnInit(): void {

    this.showSpinner = true;

    const id = 'nhXbbjaNfi6xgf9xWBhK';

    this.sharedService.getBanner(id).then(result => {

      if (result && result.image) {

        const bgCover = document.getElementById('bg-cover');

        if (bgCover) {
          bgCover.style.backgroundImage =
            'url(' + result.image.fileUrl + ')';
        }
      }

      this.titleService.setTitle("Knowledge | CamEdu")
    });

    this.loadKnowledges();
  }

  loadKnowledges(): void {

    this.homeService
      .getKnowledgesPage(this.pageSize)
      .then(result => {

        this.knowledges = result.data;
        this.lastDoc = result.lastDoc;
        this.hasNextPage = result.hasNextPage;

        this.showSpinner = false;

      })
      .catch(error => {

        console.error(error);

        this.showSpinner = false;

      });
  }

  loadMore(): void {

    if (
      this.loadingMore ||
      !this.hasNextPage ||
      !this.lastDoc
    ) {
      return;
    }

    this.loadingMore = true;

    this.homeService
      .getKnowledgesPage(
        this.pageSize,
        this.lastDoc
      )
      .then(result => {

        this.knowledges = [
          ...this.knowledges,
          ...result.data
        ];

        this.lastDoc = result.lastDoc;
        this.hasNextPage = result.hasNextPage;

        this.loadingMore = false;

      })
      .catch(error => {

        console.error(error);

        this.loadingMore = false;

      });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {

    // Prevent multiple API requests
    if (
      this.loadingMore ||
      !this.hasNextPage
    ) {
      return;
    }

    // Current scroll position
    const scrollTop =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    // Visible browser height
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight;

    // Full page height
    const documentHeight =
      Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight
      );

    // Distance from current position to bottom
    const distanceFromBottom =
      documentHeight -
      (scrollTop + windowHeight);

    // Load earlier on mobile
    const threshold =
      window.innerWidth <= 768
        ? 1400
        : 600;

    // Load next data
    if (
      distanceFromBottom <= threshold
    ) {
      this.loadMore();
    }
  }
}